import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '../../components/ui/Toast.jsx'
import { api, errorMessage } from '../api.js'
import { qk } from './keys.js'

export const sybillQuery = queryOptions({
  queryKey: qk.sybill,
  queryFn: ({ signal }) => api('/sybill', { signal }),
  staleTime: 60_000,
})

/** The organization's Sybill key status: { connected, scopes, connectedAt, canManage }. */
export function useSybillConnection() {
  return useQuery(sybillQuery)
}

/** Admins only. The key is checked with Sybill, stored encrypted, and never sent back. */
export function useSaveSybillKey() {
  const queryClient = useQueryClient()
  const toast = useToast()
  return useMutation({
    mutationFn: (apiKey) => api('/sybill', { method: 'PUT', body: { apiKey } }),
    onSuccess: (data) => {
      queryClient.setQueryData(qk.sybill, data)
      toast.success('Sybill connected')
    },
    onError: (error) => toast.error(errorMessage(error, 'Could not save that key.')),
  })
}

/** Transcript lines for one weekly call, fetched when the meeting is opened. */
export function useTranscript(projectId, weekOf, enabled) {
  return useQuery({
    queryKey: qk.transcript(projectId, weekOf),
    queryFn: ({ signal }) => api(`/projects/${projectId}/calls/${weekOf}/transcript`, { signal }).then((d) => d.transcript),
    enabled,
    staleTime: 5 * 60_000,
  })
}

/** Sybill recording links expire after 24 hours, so a fresh one is requested on each play. */
export const fetchRecording = (projectId, weekOf) => api(`/projects/${projectId}/calls/${weekOf}/recording`)
